import React from "react";
import Testimonials from "../home/Testimonials";

const HospitalityTestimonials = () => {
  return <Testimonials />;
};

export default HospitalityTestimonials;
